import { useQuery } from "react-query";
import { INavigationItem } from "../../services/navigation-data-service/Models";
import NavigationDataService from "../../services/navigation-data-service/NavigationDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseGroupParameters = {
    customerID: number,
    groupID: number        
} & BaseUseQueryParameters<INavigationItem | undefined>;

export function useGroup({
    customerID,
    groupID,
    enabled,
    onError,
    onSuccess,
    //refreshSeconds
}: UseGroupParameters) {
    return useQuery<INavigationItem | undefined, RestError>(
        keys.group(customerID, groupID),
        () => {
            return NavigationDataService.getNavigationGroup(customerID, 
                groupID,
                {
                    includeAncestors: true
                } 

            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: false,
            staleTime: Infinity
            //refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false,
        }
    );
}